import React from 'react';
import { Modal, Button, Input, Select } from 'antd';

interface LayerPropertiesModalProps {
  visible: boolean;
  onCancel: () => void;
  onSave: () => void;
  layerProps: { name: string; alias: string };
  setLayerProps: (val: any) => void;
  isLoading: boolean;
}

const LayerPropertiesModal: React.FC<LayerPropertiesModalProps> = ({ visible, onCancel, onSave, layerProps, setLayerProps, isLoading }) => {
  return (
    <Modal
      open={visible}
      title="LAYER PROPERTIES"
      onCancel={onCancel}
      footer={
        <div className="footerContent">
          <Button type="primary" loading={isLoading} onClick={onSave}>
            Save
          </Button>
        </div>
      }
      width={500}
      className="layerPropsModal"
    >
      <div className="inputGroup">
        <div className="fieldRow">
          <label className="fieldLabel">LAYER NAME</label>
          <Input placeholder="Enter Layer Name" value={layerProps.name} onChange={(e) => setLayerProps({ ...layerProps, name: e.target.value })} />
        </div>
        <div className="fieldRow">
          <label className="fieldLabel">ALIAS</label>
          <Input placeholder="Enter Alias" value={layerProps.alias} onChange={(e) => setLayerProps({ ...layerProps, alias: e.target.value })} />
        </div>
        <div className="fieldRow">
          <label className="fieldLabel">SYMBOLOGY</label>
          {/* Additive, non-functional placeholder (disabled) — must not affect
              the save payload. Renders the design's Symbology control only. */}
          <Select className="symbologySelect" disabled value="use-existing" options={[{ label: 'USE EXISTING', value: 'use-existing' }]} />
        </div>
      </div>
    </Modal>
  );
};

export default LayerPropertiesModal;
